module.exports = __webpack_public_path__ + "static/img/roy.fc25762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roy.png
// module id = VJtJ
// module chunks = 0